import Vue from 'vue';
import Notifications from 'vue-notification';
import axios from 'axios';
import store from './store';
import router from './router';

// eslint-disable-next-line import/extensions
import App from './App.vue';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';

Vue.use(Notifications);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  axios,
  render: (h) => h(App),
}).$mount('#app');
